import {useContext} from 'react';
import {InterceptorContext} from '@jobseeker/common-core/components';

const useInterceptor = (): any => {
  const interceptor = useContext(InterceptorContext);

  return interceptor;
};

export default useInterceptor;
